import { ImportSetSectionType } from 'app/area/import-sets-administration/form/metroline/types';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { ImportSetAdminState } from '../types-store';
import { hasChanges } from './utils/has-changes';

export interface ImportSetFormSelectorProps {
  id: number;
  favouriteId: number;
  shouldPrompt: boolean;
  section: ImportSetSectionType;
}

type ImportSetFormSelectors = { [T in keyof ImportSetFormSelectorProps]?:
  (state: ImportSetAdminState, props: DefaultContainerProps) => ImportSetFormSelectorProps[T] };

export const selectors: ImportSetFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.importSetItem, form?.originalImportSetItem),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
